<script type="ts">
	import { onMount } from 'svelte';

	import EventNextBanner from './EventNextBanner.svelte';

	import { storeSettings } from '../../store/StoreSettings';
	import { applyColors } from '../../utils';

	export let publicKey: string;
	export let primaryColor: string;
	export let secondaryColor: string;
	export let buttonText: string;
	export let darkMode: boolean;
	export let borderRadius: boolean;

	storeSettings.set({
		publicKey: publicKey,
		primaryColor: primaryColor ? `${primaryColor}` : '#e52b51',
		secondaryColor: secondaryColor ? `${secondaryColor}` : '#f3f3f3',
		darkMode: darkMode,
		borderRadius: borderRadius || false,
		buttonText: buttonText
	});

	onMount(() => {
		applyColors({ primary: primaryColor, secondary: secondaryColor });
	});
</script>

<div class="cobraticket-widget">
	<EventNextBanner />
</div>

<style global>
	@tailwind base;
	@tailwind components;
	@tailwind utilities;

	@layer utilities {
		input[type='number']::-webkit-inner-spin-button,
		input[type='number']::-webkit-outer-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}
	}
</style>
